import { FC } from "react"
import { useHeroVitals } from "@/hooks/useHeroVitals"
import { HeroVitalsContext } from "./HeroVitals.context"
import { IHeroVitalsProviderProps } from "./types"

export const HeroVitalsProvider: FC<IHeroVitalsProviderProps> = ({
  children
}) => {
  const vitals = useHeroVitals()

  return (
    <HeroVitalsContext.Provider value={vitals}>
      {children}
    </HeroVitalsContext.Provider>
  )
}
